// extracted by mini-css-extract-plugin
export var bodySections = "_e5-8";
export var gray = "_e5-7";
export var green = "_e5-4";
export var iconContainer = "_e5-9";
export var iconWidgetContainer = "_e5-1";
export var phoneIcon = "_e5-2";
export var red = "_e5-5";
export var statusDot = "_e5-3";
export var widgetContainer = "_e5-0";
export var yellow = "_e5-6";